/***
**Module Name: Company details
 **File Name :  Company.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains compant tables details.
 ***/

import React, { useState, useEffect, useContext } from "react";


import Footer from "../../../components/dashboard/footer";
import Header from "../../../components/dashboard/header";
import Sidebar from "../../../components/dashboard/sidebar";
import tmdbApi from "../../../api/tmdbApi";
import { useHistory, Link, useLocation } from "react-router-dom";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../../context/contentContext";
import SessionPopup from "../../SessionPopup"
import DataTable from 'react-data-table-component';
import TableLoader from "../../../components/tableLoader";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import Loader from "../../../components/loader";
let { lambda, appname } = window.app;



const Company = () => {
    const history = useHistory();
    const { state } = useLocation();
    const { search } = state || {};
    // const [toggle, setToggle] = useState(false);
    const [content, setContent] = useState("");
    const [success, setSuccess] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [deleteQuiz, setdeleteQuiz] = useState(false);
    const [quizId, setQuizId] = useState(null);
    // const [data, setData] = useState([]);
    const [itemsPerPage, setitemsPerPage] = useState(10);
    const [tableErrMsg, setTableErrMsg] = useState(false);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [loaderEnable, setLoaderEnable] = useState(false);
    const [contentLoaded, setcontentLoaded] = useState(false);

    const [searchvalue, setSearch] = useState("");
    const [quizzes, setQuizzes] = useState([]);

     const [duplicateSuccess, setDuplicateSuccess] = useState(false);
    const [duplicateQuiz, setduplicateQuiz] = useState(false);


    const handleClosePopup = () => setShowPopup(false);

    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    const [sortDirection, setSortDirection] = useState('asc');

    const [image, setImg] = useState('');

    const [popup, setShowPopup] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, processObject, sortTableAlpha, arrow, sortTableByDate, userData, companysearch, setCompanySearch, companyadvSearch, setCompanyAdvSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext)

    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu == "Client Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].submenus && validateObj[0].submenus[1] && validateObj[0].submenus[1].dashboard


    const getSerialNumber = (index) => {
        // Serial number calculation: it continues from the last serial number of the previous page
        return (currentPage - 1) * rowsPerPage + index + 1;
    };


    const columns = [
        {
            name: 'Sl No',
            selector: (row, index) => {
                return getSerialNumber(index);
            },
        },
        {
            name: 'Quiz Name',
            selector: row => row?.name ?? "",
           // sortable: true,
        },
        {
            name: <span class="material-symbols-outlined icon" title="Participants">
                group
            </span>
            ,
            selector: row => row?.participants ?? 0,
           // sortable: true,
        },
        {
            name: <span class="material-symbols-outlined icon" title="Live Participants">
                spatial_audio_off
            </span>,
            selector: row => row?.liveparticipants ?? 0,
           // sortable: true,
        },
        {
            name: 'Type',
            selector: row => row?.quizType ?? "",
          //  sortable: true,
        },
        // {
        //     name: 'Start Date',
        //     selector: row => row?.startDate,
        //     cell: (props) => props?.startDate ? moment.utc(props?.startDate).format('DD MMM YYYY, h:mm A') : "",
        //     sortable: true,
        //     // sortFunction: (a, b) => moment(a.created).diff(b.created),
        // },
        // {
        //     name: 'End Date',
        //     selector: row => row?.endDate,
        //     cell: (props) => props?.endDate ? moment.utc(props?.endDate).format('DD MMM YYYY, h:mm A') : "",
        //     sortable: true,
        //     // sortFunction: (a, b) => moment(a.created).diff(b.created),
        // },
        {
            name: 'Created Date',
            selector: row => row?.created,
            cell: (props) => props?.created ? new Date(props?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                // hour: 'numeric',
                // minute: 'numeric',
            }) : "",
          //  sortable: true,
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },
        {
            name: 'Status',
            selector: row => row?.status ?? "",
        },

        {
            name: 'Actions',
            cell: (props) =>
                //  {subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
                <div className="d-flex">
                    <a title="Duplicate Quiz" onClick={(e) => handleDuplicateQuiz(e, props)} className='text-info action-button'><i className="mdi mdi-file font-size-18"></i></a>

                    {/* {props.status == "UPCOMING" && */}
                    <a title="Edit Quiz" onClick={(e) => handleEdit(e, props)} className='text-info action-button'><i className="mdi mdi-pencil font-size-18"></i></a>
                    {/* } */}

                     {/* {props.status == "INACTIVE" && */}
                        <a title="Add Questions" onClick={(e) => handleAddQuestions(e, props?.quizid)} className='text-success action-button'><i className="mdi mdi-plus font-size-18"></i></a> 
                        {/* } */}

                    {/* {props.status == "UPCOMING" ?
                        <a title="Add Questions" onClick={(e) => handleAddQuestions(e, props?.quizid)} className='text-success action-button'><i className="mdi mdi-plus font-size-18"></i></a> :
                        <a title="View Quiz" onClick={(e) => handleView(e, props)} className='text-info action-button'><i className="mdi mdi-eye font-size-18"></i></a>} */}

                    {/* <a title="View Quiz" onClick={(e) => handleView(e, props)} className='text-info action-button'><i className="mdi mdi-eye font-size-18"></i></a> */}

                   
                        <a title="Delete Quiz" onClick={(e) => handleDelete(e, props)} className='text-danger action-button'><i className="mdi mdi-delete font-size-18"></i></a>




                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }

    }, [window.site]);
    const keyForRerender = `${rowsPerPage}_${data?.length}`;

    const handlePageChange = (page) => {
        setcurrentPage(page);

    };

    const handlePerRowsChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
    };


    const handleShowPopup = () => {
        setShowPopup(true);
    };

    

    useEffect(() => {

        if (!localStorage.getItem("token")) {
            history.push("/admin");
        }
        GetQuizInfo()
        setcurrentPage(1);
    }, []);
    // console.log('dataaaaaaaa',data)
    const handleExport = () => {

        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "COMPANY NAME": Array.isArray(each?.companyname) ? each?.companyname?.[0] : each?.companyname ?? "",
            "EMAIL ID": each?.emailid ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            "COMPANY TYPE": each?.companytype ?? "",
            "ENTITY": each?.entity ?? "",
            "CONTENT TYPE": each?.contenttype ?? "",
            "ACCOUNT MANAGER": each?.accountmanager ?? "",

            "CREATED ON": each?.created ? new Date(each?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',

            }) : "",
            // "STATUS": status,
        }));
        // console.log('data2 after',data2)

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data, `CompaniesData.xlsx`);
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };




    const GetQuizInfo = async () => {
        setIsLoading(true)
        try {
            const response = await tmdbApi.quizInfo();
            setQuizzes(response?.result);
            setIsLoading(false)
            setcontentLoaded(true)
        } catch {
            console.log("error");
            setcontentLoaded(true)
        }
    };


    const handleAdd = () => {
        GetTimeActivity()
        history.push("/admin/addquiz")
    }
    const handleSearch = async (e) => {
        setIsLoading(true)
        try {    const response = await tmdbApi.quizSearchInfo(searchvalue);
                setQuizzes(response?.result);
                setIsLoading(false);
            

        } catch {
            console.log("error");
        }
    }
    function onConfirm() {
        GetTimeActivity()
        setSuccess(false);


    };

    const ondeleteConfirm = (e) => {
        setDeleteSuccess(false)
        GetQuizInfo()
        setQuizId(null)
    }

    const onDelete = async (e) => {
        try {
            const response = await tmdbApi.deleteQuiz(quizId);
            setDeleteSuccess(true)
        } catch {
            console.log("error");
        }
        setDeleteSuccess(true)
        setdeleteQuiz(false)

    }

    const onCancel = (e) => {
        setdeleteQuiz(false)

    }

    const handleDelete = async (e, quiz) => {

        setdeleteQuiz(true)
        setQuizId(quiz.quizid)

    }

    const handleChange = (e) => {
        setSearch(e.target.value)
    }

    const clearSearch = () => {
        setSearch(null);
        GetQuizInfo()
    }
    const clearadvSearch = () => {
        GetTimeActivity()
        setCompanyAdvSearch({ ...companyadvSearch, companyname: "", emailid: "", phone: "", companytype: "", entity: "", contenttype: "", accountmanager: "", created: "", status: "" })
    }
    const handleAdvChange = (e) => {
        GetTimeActivity()
        setCompanyAdvSearch({ ...companyadvSearch, [e.target.name]: e.target.value });
    }

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No content found</p>
                </div> </div>
        )
    }

    const handleAddQuestions = (e, id) => {
        history.push("/admin/addquestion/" + id);
    }


    const handleEdit = (e, quizinfo) => {
        // console.log("quizInfoooooooooooo",quizinfo);
        localStorage.setItem('eq', JSON.stringify(quizinfo))
        history.push({
            pathname: "/admin/editquiz/"+quizinfo?.quizid,
            state: { quizinfo }
        });
    }

    const handleView = (e, quizinfo) => {
        localStorage.setItem('eq', JSON.stringify(quizinfo))
        history.push({
            pathname: "/admin/viewquiz/"+quizinfo?.quizid,
            state: { quizinfo }
        });
    }

    const handleDuplicateQuiz = async (e, quiz) => {
        setduplicateQuiz(true)
        setQuizId(quiz.quizid)
    }

    const onduplicateConfirm = (e) => {
        setDuplicateSuccess(false)
        setQuizId(null)
        GetQuizInfo()
    }

    const onDuplicate = async (e) => {
        try {
            const response = await tmdbApi.duplicateQuiz(quizId);
            setDuplicateSuccess(true)
        } catch {
            console.log("error");
        }
        setDuplicateSuccess(true)
        setduplicateQuiz(false)

    }

    const onDuplicateCancel = (e) => {
        setduplicateQuiz(false)

    }

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                {isLoading ? <Loader /> : <div className="quiz-page main-content user-management clients company quiz-section-page">

                    <div className="page-content">
                        <div className="container-fluid">



                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">QUIZ</h4>
                                            {/* <p className="menu-path">Client Management / <b>Company</b></p> */}
                                        </div>

                                        <div>
                                            <button onClick={handleAdd} className="btn btn-primary" >CREATE QUIZ</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row mb-2">
                                                {/* <div className="col-sm-4 button-block"> */}
                                                {/* <div className="dataTables_length" id="datatable_length">
                                                      <button className={`fill_btn ${data.length <= 0 ?'disable pe-none':''}`} onClick={handleExport}><span className="material-icons">north_east</span>Export</button>
                                                  </div> */}
                                                {/* </div> */}
                                                <div className="col-sm-8">
                                                    <div className="search-box mb-2 d-inline-block">

                                                        <div className="position-relative">
                                                            <input type="text" className="form-control" value={searchvalue ? searchvalue : ""} placeholder="Search " onChange={(e) => handleChange(e)} />
                                                            <button className="fill_btn" onClick={(e) => handleSearch(e)} >
                                                                <span className="material-icons search-icon">search</span>
                                                            </button>
                                                        </div>
                                                        {/* <div className="dataTables_length" id="datatable_length">
                                         <button className="fill_btn" onClick={handleShowPopup}>Advanced Search</button>
                                     </div> */}
                                                        <div className="dataTables_length" id="datatable_length">
                                                            <button className="fill_btn" onClick={(e) => clearSearch(e)}><span className="material-icons-outlined">sync</span>Reset</button>
                                                        </div>

                                                    </div>
                                                    <div className="text-sm-end">

                                                    </div>
                                                </div>
                                            </div>


                                            <DataTable key={keyForRerender} className="quiz_table"
                                                // title=""
                                                columns={columns}
                                                // className="table align-middle table-nowrap table-check"
                                                keyField='_id'
                                                data={quizzes}
                                                direction="auto"
                                                highlightOnHover
                                                fixedHeaderScrollHeight="300px"
                                                pagination
                                                responsive
                                                persistTableHead
                                                // selectableRowsVisibleOnly
                                                striped
                                                // selectableRowsHighlight
                                                // selectableRows
                                                subHeaderAlign="right"
                                                defaultSortField="name"
                                                subHeaderWra
                                                noDataComponent={customNoRecords()}
                                                paginationTotalRows={quizzes?.length}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                paginationPerPage={rowsPerPage}
                                                paginationDefaultPage={currentPageNew}
                                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                sortFunction={customSort}

                                                paginationComponentOptions={{
                                                    rowsPerPageText: 'Per page:',
                                                    rangeSeparatorText: 'of',
                                                    noRowsPerPage: false,
                                                    selectAllRowsItem: false,
                                                    selectAllRowsItemText: 'All',
                                                }}

                                            //  progressPending={isLoading}
                                            //  progressComponent={<TableLoader />}
                                            />


                                            {contentLoaded && quizzes && quizzes.length == 0 &&
                                                customNoRecords()
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                    <SweetAlert show={success}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"No Results Found"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteQuiz}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure to delete the Quiz?"
                        focusCancelBtn
                        onConfirm={e => onDelete()}
                        onCancel={e => onCancel()}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Deleted Successfully"}
                        onConfirm={e => ondeleteConfirm()}
                    >
                    </SweetAlert>

                  <SweetAlert show={duplicateQuiz}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure to duplicate the Quiz?"
                        focusCancelBtn
                        onConfirm={e => onDuplicate()}
                        onCancel={e => onDuplicateCancel()}
                    >
                    </SweetAlert> 

                    <SweetAlert show={duplicateSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Duplicate Created Successfully"}
                        onConfirm={e => onduplicateConfirm()}
                    >
                    </SweetAlert>



                    <Footer />
                </div>
                }


            </div>
        </>
    );
};

export default Company;
